import React from 'react';
import { Link } from 'react-router-dom';
import { useLocalization } from '@ais-ui/locale-management';

interface EmptyListProps {
  entity: string;
  srcImage: string;
  to: string;
}

export const EmptyCommand = ({ entity, srcImage, to }: EmptyListProps) => {
  const { messages } = useLocalization();
  const noItemsMessage = messages.emptyStateNoItems?.replace('{entity}', entity) ?? `No ${entity} to display`;
  const addMessage = messages.emptyStateNoItemsAdd?.replace('{entity}', entity) ?? `Add ${entity}`;

  return (
    <div className="flex flex-col w-full h-full justify-center items-center self-center my-2">
      <img className="max-h-96 w-[60%]" src={srcImage} alt="EmptyList" />
      <div className="flex flex-col items-center justify-center my-4 space-y-2">
        <div className="text-sm text-muted-foreground text-center">
          {noItemsMessage}
        </div>
        <div className="text-sm text-muted-foreground text-center">
          <Link
            to={to}
            className="text-sm text-center text-blue-500 hover:underline"
          >
            {addMessage}
          </Link>
        </div>
      </div>
    </div>
  );
};
